import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  CATALOG_RIGHTHOLDER_BOOK_LIST_SET_DATA,
  CATALOG_RIGHTHOLDER_BOOK_LIST_RESET_DATA,
} from 'rebook/apps/catalog/constants';


export const fetchInitialData = (match, location = {}) => {
  return async(dispatch, getState) => {
    const { ssr, rightholderBookList: currentState } = getState();
    const rightholderSlug = get(match, 'params.rightholderSlug', '');
    const orderBy = get(ssr, 'query.o', 'popular');
    const subscriptionId = get(ssr, 'query.s', null);
    const bookType = get(ssr, 'query.t', null);
    const pageNumber = ssr.query && ssr.query.page
      ? parseInt(ssr.query.page, 10)
      : 1;

    let newState = {
      rightholderSlug,
      pageNumber,
      orderBy,
      subscriptionId,
      bookType,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }

    if (currentState) {
      newState = {
        ...currentState,
        ...newState,
      };
    }

    if (get(newState, 'rightholder.id', false)) {
      dispatch(setData({
        rightholder: newState.rightholder,
      }));
    }

    if (!newState.rightholder) {
      await dispatch(fetchRightholder(newState.rightholderSlug));
    }

    if (get(newState, 'rightholder.id', false)) {
      await dispatch(fetchBookList({ ...newState }));
    }
  };
};

export const fetchRightholder = (rightholderSlug) => {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/rightholders/s-${rightholderSlug}/`;
    return await (
      fetchQuery(url, { headers: ssr.headers })
        .then(({ data }) => {
          dispatch(setData({
            rightholder: data,
          }));
        })
        .catch(({ data, resp, error }) => {
          const status = get(resp, 'status', null);
          if (status === 404) {
            dispatch(Error404Actions.show());
            return;
          }
          else {
            Raven.captureMessage('failed to load rightholder data due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load rightholder data due to server error');
          }
        })
    );
  };
};

export const fetchBookList = (params = {}) => {
  return async(dispatch, getState) => {
    const { ssr, rightholderBookList } = getState();
    const mergedState = { ...rightholderBookList, ...params };
    const { rightholder, paginateBy, orderBy, subscriptionId, bookType } = mergedState;
    let pageNumber = mergedState.pageNumber || 1;
    const queryParams = {
      rightholders: rightholder.id,
      author_weight__gte: 0,
      offset: (pageNumber - 1) * paginateBy,
      limit: paginateBy,
      o: orderBy,
      ...(subscriptionId !== null && { subscription_id__in: subscriptionId }),
      ...(bookType !== null && { type: bookType }),
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/books/?${qs}`;

    dispatch(setData({
      bookList: null,
    }));

    return await (
      fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
        .then(({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / paginateBy);
          dispatch(setData({
            bookList: data.objects,
            totalBookCount: data.meta.total_count,
            orderBy,
            subscriptionId,
            bookType,
            lastPageNumber,
            pageNumber,
          }));
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load book list from rightholder data due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load book list from rightholder data due to server error');
        })
    );
  };
};

export const setData = (payload) => {
  return (dispatch) => {
    dispatch({
      type: CATALOG_RIGHTHOLDER_BOOK_LIST_SET_DATA,
      payload,
    });
  };
};

export function resetData() {
  return (dispatch) => {
    dispatch({
      type: CATALOG_RIGHTHOLDER_BOOK_LIST_RESET_DATA,
    });
  };
};
